import 'leaflet/dist/leaflet.css';
import './Nav.css'
import { useState, useEffect, ReactNode } from 'react'
import StatusText from '../StatusText';
import useDroneHubConnection from '../../../hooks/DroneHubConnection';
import { HubStatusTextMessage, HubStatusTextSchema } from '../../../asp/DroneHub';

interface MsgBoxProps {
    imei: string;
    startMsgs: HubStatusTextMessage[];
}

function MsgBox({ imei, startMsgs }: MsgBoxProps): ReactNode {
    const droneHub = useDroneHubConnection();

    const [statusText, setStatusText] = useState<HubStatusTextMessage[]>(startMsgs);
    const [showMsgs, setShowMsgs] = useState<boolean>(false);

    useEffect(() => {
        droneHub.connection.onreconnecting(() => {
            console.log("hub status text reconnect");
        });

        droneHub.connection.on('StatusText', (message: HubStatusTextMessage) => {
            const result = HubStatusTextSchema.safeParse(message);
            if (result.success) {
                setStatusText((prevText) => {
                    const filtered = prevText.filter((msg) => msg.imei !== result.data.imei);
                    const sameImei = prevText.filter((msg) => msg.imei === result.data.imei);

                    return [...filtered, ...sameImei.slice(-2), result.data];
                });
            } else {
                console.error(result.error);
            }
        });
    }, [droneHub]);

    useEffect(() => {
        //setStatusText(startMsgs);
    }, [startMsgs]);

    function getClassColor(severity: number): string {
        if (severity <= 0) {
            return 'addition-white'
        }
        if (severity <= 2) {
            return 'addition-red'
        }
        if (severity <= 4) {
            return 'addition-yell'
        }
        return 'addition-white';
    }

    return (
        <div className={'header-box msg-box-container'} >
            <div
                className={'msg-box ' + getClassColor(statusText.findLast((t) => t.imei === imei)?.severity ?? 0)}
                onClick={() => { setShowMsgs((s) => !s); }}
            >
                <span className='msg-box-text'>{statusText.findLast((t) => t.imei === imei)?.message}</span>
            </div>
            <StatusText imei={imei} showMsgs={showMsgs} startMsgs={startMsgs} />
        </div>
    )
}

export default MsgBox;